// extracted by mini-css-extract-plugin
module.exports = {"Scroller":"TagList_Scroller__cHGPi"};